import React, { ChangeEvent } from 'react';
import { RadioGroup } from '@material-ui/core';
import { LabelFormControl, RadioButton } from '@cambridgeassessment/cambridge-ui';
import { Component, ComponentValidation } from '@cambridgeassessment/lib-ee-commons';
import { useDispatch } from 'react-redux';
import * as thunks from '../../../../../store/components/thunks';
import { StyledColumn } from './styles';

interface Props {
  component: Component;
  disabled: boolean | undefined;
}

const SubmissionValidationPicker = ({ component, disabled }: Props): JSX.Element => {
  const dispatch = useDispatch();

  const handleValidationChange = (event: ChangeEvent, val: string) => {
    dispatch(
      thunks.updateComponent(
        component._id,
        {
          ...component,
          submissionValidation: val as ComponentValidation,
        },
        'submissionValidation',
      ),
    );
  };

  return (
    <div>
      <StyledColumn>Choose submission validation:</StyledColumn>
      <RadioGroup
        value={component.submissionValidation || ComponentValidation.AT_LEAST_ONE_SECTION_UPLOADED}
        onChange={handleValidationChange}
        tabIndex={0}
        aria-label={'Submission validation radio group'}
      >
        <LabelFormControl
          disabled={disabled}
          dataQaId={ComponentValidation.AT_LEAST_ONE_SECTION_UPLOADED}
          value={ComponentValidation.AT_LEAST_ONE_SECTION_UPLOADED}
          control={<RadioButton dataQaId={ComponentValidation.AT_LEAST_ONE_SECTION_UPLOADED} />}
          label=''
          labelElement={
            <span data-qa-id={`${ComponentValidation.AT_LEAST_ONE_SECTION_UPLOADED}-description`}>
              Allow submission when each candidate in the sample has
              <strong> at least one </strong>
              learner section uploaded
            </span>
          }
        />
        <LabelFormControl
          disabled={disabled}
          dataQaId={ComponentValidation.ALL_SECTIONS_UPLOADED}
          value={ComponentValidation.ALL_SECTIONS_UPLOADED}
          control={<RadioButton dataQaId={ComponentValidation.ALL_SECTIONS_UPLOADED} />}
          label=''
          labelElement={
            <span data-qa-id={`${ComponentValidation.ALL_SECTIONS_UPLOADED}-description`}>
              Allow submission only when each candidate in the sample has
              <strong> all </strong>
              of their learner sections uploaded
            </span>
          }
        />
        <LabelFormControl
          disabled={disabled}
          dataQaId={ComponentValidation.ALWAYS_ALLOW}
          value={ComponentValidation.ALWAYS_ALLOW}
          control={<RadioButton dataQaId={ComponentValidation.ALWAYS_ALLOW} />}
          label=''
          labelElement={
            <span data-qa-id={`${ComponentValidation.ALWAYS_ALLOW}-description`}>Always allow submissions</span>
          }
        />
      </RadioGroup>
    </div>
  );
};

export default SubmissionValidationPicker;
